import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ChartBarComponent } from './chart-bar/chart-bar.component';
import { FinancialCardComponent } from './financial-card/financial-card.component';

const DECLARATIONS = [ChartBarComponent, FinancialCardComponent];

@NgModule({
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
  imports: [CommonModule, SharedModule]
})
export class FinancialInfoComponentsModule {}
